var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-list"},[_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"export-data-options":_vm.exportDataOptions,"show-group-actions":true,"show-page":false,"refresh-method":_vm.refresh,"single-actions":_vm.singleActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }